export default {
    'add-new-review': 'إضافة مراجعة جديدة',

}